/* PDP v3 (2026-09-26) — vertical accordion helpers for sections/ame-pdp-main.liquid.
   The sections are native <details>/<summary>, so opening, closing, keyboard activation and the expanded
   state need no script. This file only makes in-page links land on content inside a closed section:
     • a[href^="#tab-"] and [data-jump-to-tab] links open the enclosing <details>, then scroll to it;
     • a URL hash that points inside a section opens it on load;
     • window.AmeAcc.reveal(el) is shared with assets/ame-pdp-state.js (fabric / specs jumps).
   The FAQ question toggles inside the FAQ section are unchanged. */
(function () {
  function reveal(el) {
    var d = el && el.closest ? el.closest('details') : null;
    while (d) { d.open = true; d = d.parentElement ? d.parentElement.closest('details') : null; }
  }
  window.AmeAcc = { reveal: reveal };

  function targetFor(link) {
    var id = link.getAttribute('data-jump-to-tab');
    if (!id) { var href = link.getAttribute('href') || ''; if (href.charAt(0) === '#') id = href.slice(1); }
    return id ? document.getElementById(id) : null;
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href^="#tab-"], [data-jump-to-tab]') : null;
    if (!link) return;
    var panel = targetFor(link);
    if (!panel) return;
    e.preventDefault();
    reveal(panel);
    // 2026-10-16: a link to a sub-section (#tab-warranty inside Delivery & Support) lands on that sub-section's own box, not
    // on the group's top; a link to the group itself (the content navigator) lands on the group.
    var box = panel.matches('details') ? panel : (panel.closest('.ame-acc__sub') || panel.closest('details') || panel);
    requestAnimationFrame(function () {
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var sum = box.matches('details') ? box.querySelector('summary') : null;
      if (sum) sum.focus({ preventScroll: true });
      else if (box.querySelector) { var h = box.querySelector('h3, h2'); if (h) { if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); } }
    });
  });

  function openFromHash() {
    if (!location.hash || location.hash.length < 2) return;
    var el = null;
    try { el = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (err) { el = null; }
    if (el) reveal(el);
  }
  openFromHash();
  window.addEventListener('hashchange', openFromHash);

  // FAQ accordion (questions inside the FAQ section)
  document.querySelectorAll('.ame-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      var answer = document.getElementById(this.getAttribute('aria-controls'));
      if (answer) answer.classList.toggle('is-open');
    });
  });
})();

/* 2026-10-16 (PDP redesign) — six grouped sections. On phones they are the accordions they always were (Highlights open,
   the rest closed; what the shopper opens stays open through a rotate). From 990px every group is OPEN: the desktop page
   is structured, visible content under one row of anchor links — not a wall of closed rows and not hidden tabs. A group can
   still be collapsed by its heading; the state is re-applied only when the layout crosses the breakpoint. The content
   navigator marks the group currently in view (aria-current) as the page scrolls. */
(function () {
  var groups = Array.prototype.slice.call(document.querySelectorAll('details.ame-acc--group'));
  if (!groups.length) return;
  var mq = window.matchMedia('(min-width: 990px)');
  var defaults = groups.map(function (d) { return d.hasAttribute('data-default-open'); });
  var wasDesktop = null;
  function apply() {
    var desktop = mq.matches;
    if (wasDesktop === desktop) return;
    wasDesktop = desktop;
    groups.forEach(function (d, i) { d.open = desktop ? true : (defaults[i] || d.dataset.userOpened === '1'); });
  }
  groups.forEach(function (d) { d.addEventListener('toggle', function () { if (!mq.matches) d.dataset.userOpened = d.open ? '1' : '0'; }); });
  apply();
  if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);

  var chips = Array.prototype.slice.call(document.querySelectorAll('.ame-cnav [data-jump-to-tab]'));
  if (!chips.length) return;
  var byId = {};
  chips.forEach(function (c) { byId[c.getAttribute('data-jump-to-tab')] = c; });
  var ticking = false;
  function spy() {
    ticking = false;
    var top = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ame-sticky-top')) || 0;
    var line = top + 230, current = null;   // a jumped-to group lands at sticky-top + 76 (scroll-margin + scroll-padding) and its heading is ~70px tall
    groups.forEach(function (d) { if (byId[d.id] && d.getBoundingClientRect().top <= line) current = d.id; });
    if (!current && groups[0] && byId[groups[0].id]) current = groups[0].id;
    chips.forEach(function (c) {
      var on = c.getAttribute('data-jump-to-tab') === current;
      if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
    });
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(spy); } }, { passive: true });
  window.addEventListener('resize', spy);
  spy();
})();

/* 2026-10-10 (PDP UX standardization): a legacy description table wider than its column scrolls sideways inside
   .ame-pdp-story__body (ame-pdp.css overflow-x:auto). A scroll container with no focusable content is unreachable from the
   keyboard (axe scrollable-region-focusable, measured on the PR-531 and the Jazzy EVO 614), so each such table becomes a
   named, focusable region. Tables that fit are left alone. Re-checked after a resize because the condition depends on width. */
(function () {
  var mark = function () {
    document.querySelectorAll('.ame-pdp .ame-acc__panel table').forEach(function (t) {
      var scrolls = t.scrollWidth > t.clientWidth + 2;
      if (scrolls && !t.hasAttribute('tabindex')) {
        t.setAttribute('tabindex', '0'); t.setAttribute('role', 'region');
        var cap = t.querySelector('caption'); var acc = t.closest('details.ame-acc'); var title = acc && acc.querySelector('.ame-acc__title');
        t.setAttribute('aria-label', (cap && cap.textContent.trim()) || ((title ? title.textContent.trim() + ' ' : '') + 'table (scrolls sideways)'));
      } else if (!scrolls && t.getAttribute('tabindex') === '0' && t.getAttribute('role') === 'region') {
        t.removeAttribute('tabindex'); t.removeAttribute('role'); t.removeAttribute('aria-label');
      }
    });
  };
  mark(); window.addEventListener('resize', mark); document.addEventListener('toggle', mark, true);
})();

/* Post-launch 2026-09-28: the section-chip row (.ame-cnav__list) scrolls horizontally with its scrollbar hidden, and
   keyboard focus left chips partly outside it (measured at 320-768px, live and staging). Bring the focused chip fully
   into view; the CSS scroll-margin keeps it clear of the trailing fade. */
(function () {
  var list = document.querySelector('.ame-cnav__list');
  if (!list) return;
  list.addEventListener('focusin', function (e) {
    var li = e.target.closest('li');
    if (li && list.scrollWidth > list.clientWidth) li.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
})();
